module.exports = __webpack_public_path__ + "img/wf-finishing-position-23.5e771e9b.svg";